__turbopack_context__.v({
  "wrapper": "details-module-scss-module__5iMZaG__wrapper",
});
